
























import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CycleDays from '@/componentsV2/molecules/CycleDays/CycleDays.vue';

@Component({
  components: {
    Typography,
    CycleDays
  }
})
export default class Cycle extends Vue {
  @Prop() startDate!: string;
  @Prop() endDate!: string;

  get tPrefix() {
    return 'modals.billing.reactivation.cycle';
  }
}
